<p-panel hisDdKey="fs.res.finance.researchContract_publication.fundingPrograms">
	<p-header><h2>{{ 'fs.res.finance.researchContracts_publication.fundingPrograms' | hisUi }}</h2></p-header>

    <span [innerHTML]="'fs.res.finance.researchContract_publication.fundingPrograms.infoMessage' | hisUi"></span>
    <br/>
    <br/>
    <button (click)="onAddNewFundingProgram()" hisImage="plus_circ_green" class="transparent"><span>{{'fs.res.finance.researchContracts_publication.addFundingProgram' | hisUi}}</span></button>
    <br/>
    <br/>

    <div *ngIf="projectFundingPrograms?.length > 0 || pseudonymizedResearchPartners?.length > 0">
        <h2>{{ 'fs.res.finance.researchContracts_publication.projectContractsList' | hisUi }}</h2>
        <br/>
        <ul class="listSimple">
            <ng-container
             [ngTemplateOutlet]="fundingProgramsList"
             [ngTemplateOutletContext]="{showDeleteBtn:false, dataList: pseudonymizedResearchPartners, pseudonymized: true, showEndline: projectFundingPrograms.length > 0}">
            </ng-container>
            <ng-container
             [ngTemplateOutlet]="fundingProgramsList"
             [ngTemplateOutletContext]="{showDeleteBtn:false, dataList: projectFundingPrograms, pseudonymized: false, showEndline: false}">
            </ng-container>
        </ul>
		<div class="clearer"></div>
	</div>
    <div *ngIf="fundingPrograms?.length > 0">
        <h2>{{ 'fs.res.finance.researchContracts_publication.publicationContractsList' | hisUi }}</h2>
        <br/>
        <ul class="listSimple">
            <ng-container
             [ngTemplateOutlet]="fundingProgramsList"
             [ngTemplateOutletContext]="{showDeleteBtn:true, dataList: getSortedFundingPrograms(), pseudonymized:false, showEndline: false}">
           </ng-container>
        </ul>
		<div class="clearer"></div>
	</div>

</p-panel>

<ng-template #fundingProgramsList let-showDeleteBtn='showDeleteBtn' let-dataList='dataList' let-pseudonymized='pseudonymized' let-showEndline='showEndline'>
    <li *ngFor="let dataEntry of dataList; index as i">
        <div class="columnTwoThird">
            <span>
                <span>{{'fs.res.finance.researchContracts_publication.funderName' | hisUi}}: </span><span *ngIf="dataEntry.funderName">{{dataEntry.funderName}}</span>
            </span>
            <br/>
            <span>
                <span>{{'fs.res.finance.researchContracts_publication.externalReferenceNumber' | hisUi}}: </span><span *ngIf="dataEntry.externalReferenceNumber">{{dataEntry.externalReferenceNumber}}</span>
            </span>
            <br/>
            <br/>
            <hr *ngIf="dataList.length > i+1">
            <hr *ngIf="showEndline && dataList.length === i+1">
        </div>
        <div class="columnOneThird">
            <button *ngIf="showDeleteBtn" (click)="editFundingProgram(i)" hisImage="PENCIL" class="icon"
                title="{{'fs.res.finance.researchContracts_publication.editFundingProgram'|hisUi:(dataEntry.funderName)}}">
            </button>
            <button *ngIf="showDeleteBtn" (click)="removeFundingProgram(dataEntry)" hisImage="DELETE" class="icon"
                title="{{'common.removeAssignmentOf' | hisUi:(dataEntry.funderName)}}">
            </button>
            <ng-template #spaceholder>
                <button disabled="true" hisImage="SPACER" class="icon"></button>
            </ng-template>
        </div>
    </li>
</ng-template>

<res-funding-program-create-dialog *ngIf="displayAddFundingProgramDialog" [fundingProgram]="fundingPrograms[editIndex]" [(display)]="displayAddFundingProgramDialog" (fundingProgramChange)="onFundingProgramChange($event)"></res-funding-program-create-dialog>
